import { Draw } from "ol/interaction";
import { Style, Fill, Stroke, Circle as CircleStyle } from "ol/style";
import { platformModifierKeyOnly } from 'ol/events/condition';
import { ResultsMessage } from "../messages/ResultsMessage";
import { BaseInteraction } from "../../lib/interaction/interactions";
import { Switchboard } from "../../lib/events";
import { Some } from "../../lib/misc/option";
import { ToolMessage } from "../messages/ToolMessage";
export class GroupInteraction extends BaseInteraction {
    constructor(layer, parcel_layer, name) {
        super();
        this.layer = layer;
        this.parcel_layer = parcel_layer;
        this.interaction_emitter = Switchboard.get_emitter("INTERACTION");
        this.ctx_emitter = Switchboard.get_emitter("CONTEXT");
        this.name = name;
        this.enter_context = new Some('group');
        switch (name) {
            case 'nh':
            case 'sale':
            case 'land':
                this.exit_context = new Some(name);
                break;
            default:
                this.exit_context = new Some('set');
        }
        this.draws = {
            polygon: this.create_polygon_select(),
            point: this.create_point_select()
        };
    }
    get geometric() { return true; }
    create_polygon_select() {
        const draw = new Draw({
            source: this.layer.source,
            type: "Polygon",
            style: new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.6)'
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 204, 51, 0.5)',
                    lineDash: [10, 10],
                    width: 2
                }),
                image: new CircleStyle({
                    radius: 5,
                    stroke: new Stroke({
                        color: 'rgba(255, 204, 51, 0.7)'
                    }),
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.6)'
                    })
                })
            })
        });
        draw.on('drawstart', this.select_start_handler.bind(this));
        draw.on('drawend', this.select_end_handler.bind(this));
        return draw;
    }
    create_point_select() {
        const ctrl_select = new Draw({
            source: this.layer.source,
            type: "Point",
            style: new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.6)'
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 204, 51, 0.5)',
                    lineDash: [10, 10],
                    width: 2
                }),
                image: new CircleStyle({
                    radius: 5,
                    stroke: new Stroke({
                        color: 'rgba(255, 204, 51, 0.7)'
                    }),
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.6)'
                    })
                })
            }),
            condition: platformModifierKeyOnly
        });
        ctrl_select.on('drawstart', this.select_start_handler.bind(this));
        ctrl_select.on('drawend', this.select_end_handler.bind(this));
        return ctrl_select;
    }
    select_start_handler(evt) {
        this.set('sketch', evt.feature);
    }
    async select_end_handler() {
        let sketch = this.get('sketch');
        let geometry = sketch === null || sketch === void 0 ? void 0 : sketch.getGeometry();
        if (geometry)
            await this.parcel_layer.add_features_by_geometry(geometry);
        let list = this.parcel_layer.ids;
        this.send_result(list, this.name);
        this.layer.clear();
    }
    init() {
        super.init();
        this.interactions.push(this.draws.polygon, this.draws.point);
        new ToolMessage({ selected: true, tool: this.name, command: "TOOL SELECTION" }).send();
        let list = this.parcel_layer.ids;
        if (list && list.length > 1) {
            this.send_result(list, this.name);
        }
    }
    remove() {
        super.remove();
        new ToolMessage({ selected: false, tool: this.name, command: "TOOL SELECTION" }).send();
    }
    send_result(list, name) {
        switch (name) {
            case 'nh':
            case 'sale':
            case 'land':
                new ResultsMessage({ command: 'RESULTS', list: list, name: this.name, type: 'group_interaction' }).send();
                break;
            default:
                new ResultsMessage({ command: 'RESULTS', list: list, name: '', type: 'group_interaction' }).send();
        }
    }
}
